import mixpanel from 'mixpanel-browser';
import { IUserProfile } from '../redux/user/actions';

/** Track when Mixpanel is initialized (token present). Skip Jest. */
const canTrack = Boolean(process.env.REACT_APP_MIXPANEL_TOKEN) && process.env.NODE_ENV !== 'test';

export type TMixPanelTrackEvent =
    | 'VIDEO_WATCH'
    | 'BUTTON_CLICK'
    | 'PAGE_NAVIGATION'
    | 'VIDEO_PAUSE'
    | 'CONTEST_CLICK'
    | 'FOLLOWED_A_THSPIAN'
    | 'UNFOLLOWED_A_THSPIAN'
    | 'ADD_BOOKMARK'
    | 'DELETE_BOOKMARK'
    | 'LOGOUT'
    | 'LOGIN'
    | 'SETTINGS_CLICK'
    | 'ACTIVE_SUBMISSIONS_CLICK'
    | 'PROCEED_WITH_RESCIND_SUBMISSION'
    | 'RESCIND_SUBMISSION_CLICK'
    | 'USER_PROJECT_CLICK'
    | 'USER_PROJECT_CLOSE'
    | 'USER_PROJECT_DELETE'
    | 'MAIN_CATEGORY_CLICK'
    | 'SUB_CATEGORY_CLICK'
    | 'APPLY_FILTER_CLICK'
    | 'CLEAR_FILTER_CLICK'
    | 'LIKE_COMMENT'
    | 'DISLIKE_COMMENT'
    | 'NOTIFICATION_OPEN'
    | ' NOTIFICATION_CLOSE'
    | 'ACCOUNT_MODAL_OPEN'
    | 'ACCOUNT_MODAL_CLOSE'
    | 'PROJECT_CREATOR_CLICK'
    | 'CONTEST_DETAILS_CLICK'
    | 'SHARE_CONTEST'
    | 'CLOSE_SHARE_CONTEST_MODAL'
    | 'OPEN_SCORE_BOARD'
    | 'ALL_RESULTS_CLICK'
    | 'SORT_BY_VOTES_CLICK'
    | 'INTERSTITIAL_AD_CLICK'
    | 'CANCEL_SUBSCRIPTION_CLICK'
    | 'PROCEED_WITH_CANCEL_SUBSCRIPTION'
    | 'KEEP_SUBSCRIPTION_CLICK'
    | 'START_TRIAL_CLICK'
    | 'SUBSCRIBE_CLICK'
    | 'MANAGE_SUBSCRIPTION_CLICK'
    | 'REACTIVATE_SUBSCRIPTION_CLICK'
    | 'DISMISS_SUBSCRIPTION_MODAL_CLICK'
    | 'EXPLORE_SUBSCRIPTION_PLANS_CLICK'
    | 'SELECT_SUBSCRIPTION_PLAN_CLICK'
    | 'MANAGE_BILLING_CLICK'
    | 'TOGGLE_SUBSCRIPTION_INTERVAL_CLICK'
    | 'SELECT_PAYMENT_METHOD_CLICK'
    | 'CONFIRM_PAYMENT_METHOD_CLICK'
    | 'SELECT_RESUME_CLICK'
    | 'UPLOAD_RESUME_CLICK'
    | 'CREATE_RESUME_CLICK'
    | 'APPLY_TO_ROLE_CLICK'
    | 'SELECT_APPLY_ROLE_CLICK'
    | 'JOIN_CAMPAIGN_CLICK'
    | 'COPY_REFERRAL_LINK_CLICK';

export enum MIXPANEL_EVENT {
    VIDEO_WATCH = 'VIDEO_WATCH',
    VIDEO_PAUSE = 'VIDEO_PAUSE',
    BUTTON_CLICK = 'BUTTON_CLICK',
    PAGE_NAVIGATION = 'PAGE_NAVIGATION',
    CONTEST_CLICK = 'CONTEST_CLICK',
    ADD_BOOKMARK = 'ADD_BOOKMARK',
    DELETE_BOOKMARK = 'DELETE_BOOKMARK',
    LOGOUT = 'LOGOUT',
    LOGIN = 'LOGIN',
    FOLLOWED_A_THSPIAN = 'FOLLOWED_A_THSPIAN',
    UNFOLLOWED_A_THSPIAN = 'UNFOLLOWED_A_THSPIAN',
    SETTINGS_CLICK = 'SETTINGS_CLICK',
    ACTIVE_SUBMISSIONS_CLICK = 'ACTIVE_SUBMISSIONS_CLICK',
    PROCEED_WITH_RESCIND_SUBMISSION = 'PROCEED_WITH_RESCIND_SUBMISSION',
    RESCIND_SUBMISSION_CLICK = 'RESCIND_SUBMISSION_CLICK',
    USER_PROJECT_CLICK = 'USER_PROJECT_CLICK',
    USER_PROJECT_CLOSE = 'USER_PROJECT_CLOSE',
    USER_PROJECT_DELETE = 'USER_PROJECT_DELETE',
    MAIN_CATEGORY_CLICK = 'MAIN_CATEGORY_CLICK',
    SUB_CATEGORY_CLICK = 'SUB_CATEGORY_CLICK',
    APPLY_FILTER_CLICK = 'APPLY_FILTER_CLICK',
    CLEAR_FILTER_CLICK = 'CLEAR_FILTER_CLICK',
    LIKE_COMMENT = 'LIKE_COMMENT',
    DISLIKE_COMMENT = 'DISLIKE_COMMENT',
    NOTIFICATION_OPEN = 'NOTIFICATION_OPEN',
    NOTIFICATION_CLOSE = ' NOTIFICATION_CLOSE',
    ACCOUNT_MODAL_OPEN = 'ACCOUNT_MODAL_OPEN',
    ACCOUNT_MODAL_CLOSE = 'ACCOUNT_MODAL_CLOSE',
    PROJECT_CREATOR_CLICK = 'PROJECT_CREATOR_CLICK',
    CONTEST_DETAILS_CLICK = 'CONTEST_DETAILS_CLICK',
    SHARE_CONTEST = 'SHARE_CONTEST',
    CLOSE_SHARE_CONTEST_MODAL = 'CLOSE_SHARE_CONTEST_MODAL',
    OPEN_SCORE_BOARD = 'OPEN_SCORE_BOARD',
    INTERSTITIAL_AD_CLICK = 'INTERSTITIAL_AD_CLICK',
    CANCEL_SUBSCRIPTION_CLICK = 'CANCEL_SUBSCRIPTION_CLICK',
    PROCEED_WITH_CANCEL_SUBSCRIPTION = 'PROCEED_WITH_CANCEL_SUBSCRIPTION',
    KEEP_SUBSCRIPTION_CLICK = 'KEEP_SUBSCRIPTION_CLICK',
    START_TRIAL_CLICK = 'START_TRIAL_CLICK',
    SUBSCRIBE_CLICK = 'SUBSCRIBE_CLICK',
    MANAGE_SUBSCRIPTION_CLICK = 'MANAGE_SUBSCRIPTION_CLICK',
    REACTIVATE_SUBSCRIPTION_CLICK = 'REACTIVATE_SUBSCRIPTION_CLICK',
    DISMISS_SUBSCRIPTION_MODAL_CLICK = 'DISMISS_SUBSCRIPTION_MODAL_CLICK',
    EXPLORE_SUBSCRIPTION_PLANS_CLICK = 'EXPLORE_SUBSCRIPTION_PLANS_CLICK',
    SELECT_SUBSCRIPTION_PLAN_CLICK = 'SELECT_SUBSCRIPTION_PLAN_CLICK',
    MANAGE_BILLING_CLICK = 'MANAGE_BILLING_CLICK',
    TOGGLE_SUBSCRIPTION_INTERVAL_CLICK = 'TOGGLE_SUBSCRIPTION_INTERVAL_CLICK',
    SELECT_PAYMENT_METHOD_CLICK = 'SELECT_PAYMENT_METHOD_CLICK',
    CONFIRM_PAYMENT_METHOD_CLICK = 'CONFIRM_PAYMENT_METHOD_CLICK',
    SELECT_RESUME_CLICK = 'SELECT_RESUME_CLICK',
    UPLOAD_RESUME_CLICK = 'UPLOAD_RESUME_CLICK',
    CREATE_RESUME_CLICK = 'CREATE_RESUME_CLICK',
    APPLY_TO_ROLE_CLICK = 'APPLY_TO_ROLE_CLICK',
    SELECT_APPLY_ROLE_CLICK = 'SELECT_APPLY_ROLE_CLICK',
    JOIN_CAMPAIGN_CLICK = 'JOIN_CAMPAIGN_CLICK',
    COPY_REFERRAL_LINK_CLICK = 'COPY_REFERRAL_LINK_CLICK',
}

/**
 * Contest Name
 * Contest Id
 */

export type TMixPanelProps<T extends TMixPanelTrackEvent> = T extends MIXPANEL_EVENT.BUTTON_CLICK
    ? { buttonName: string; buttonAction: string } // Required props for BUTTON Click event
    : Record<string, any>; // Default props for other events

function pageContext(): Record<string, string> {
    if (typeof window === 'undefined') return {};
    return {
        page: window.location.pathname,
        pageUrl: window.location.href,
    };
}

export type SubscriptionAnalyticsKind = 'creator' | 'campaign_host';

/** Shared props for subscription CTA tracking (includes current page). */
export function trackSubscriptionAction(
    event: TMixPanelTrackEvent,
    props: {
        buttonName: string;
        buttonAction: string;
        subscriptionType: SubscriptionAnalyticsKind;
        [key: string]: unknown;
    },
) {
    MixPanel.track(event, props);
}

let MixPanel = {
    identify: (id: string) => {
        if (canTrack) mixpanel.identify(id);
    },
    /** Take a user object and passes user details for identification */
    loggedInIdentify: (user: IUserProfile) => {
        if (!canTrack) return;
        mixpanel.identify(user._id);
        mixpanel.people.set({
            firstName: user.firstName,
            lastName: user.lastName,
            userName: user.userName,
            userType: user.user_type,
            location: user.location,
        });
    },
    alias: (id: string) => {
        if (canTrack) mixpanel.alias(id);
    },
    track: (name: TMixPanelTrackEvent, props: TMixPanelProps<'BUTTON_CLICK'>) => {
        if (canTrack) mixpanel.track(name, { ...pageContext(), ...props });
    },
    people: {
        /** Adds an additonal property to the person e.g => {first_login: Date} */
        set: (props: TMixPanelProps<'BUTTON_CLICK'>) => {
            if (canTrack) mixpanel.people.set(props);
        },
        setOnce: (props: TMixPanelProps<'BUTTON_CLICK'>) => {
            if (canTrack) mixpanel.people.set_once(props);
        },
        /** Ideally you sent this flag with ('tag', 'tag value') */
        append: (...args: any) => {
            if (canTrack) mixpanel.people.append(args);
        },
    },
    reset: () => {
        if (canTrack) mixpanel.reset();
    },
};

export { MixPanel };
